<template>
  <v-card outlined class="pa-3">
    <div class="subtitle-1 font-weight-bold mb-2">Readiness</div>

    <v-alert v-if="error && !preflight" type="error" dense outlined class="mb-0">
      {{ error }}
      <v-btn small text color="error" class="ml-2" @click="$emit('retry')">Retry</v-btn>
    </v-alert>

    <div v-else-if="!preflight" class="grey--text text--darken-1">Choose a CVC to see its readiness.</div>

    <template v-else>
      <v-alert
        v-for="(text, i) in preflight.blockingIssues || []"
        :key="`blocker-${i}`"
        type="error"
        dense
        outlined
        class="mb-2"
      ><readiness-text :text="text" /></v-alert>

      <v-expansion-panels v-if="warnings.length > 3" accordion flat class="mb-2">
        <v-expansion-panel>
          <v-expansion-panel-header class="px-0 amber--text text--darken-3">
            <strong>Warnings ({{ warnings.length }})</strong>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="px-0">
            <v-alert
              v-for="(text, i) in warnings"
              :key="`warning-${i}`"
              type="warning"
              dense
              outlined
              class="mb-2"
            ><readiness-text :text="text" /></v-alert>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <template v-else>
        <v-alert
          v-for="(text, i) in warnings"
          :key="`warning-${i}`"
          type="warning"
          dense
          outlined
          class="mb-2"
        ><readiness-text :text="text" /></v-alert>
      </template>

      <div class="mt-1">
        <span class="font-weight-medium mr-3">Pool</span>
        <span class="mr-6" :class="{ 'red--text font-weight-bold': pool.pppoeShort }">{{ pool.pppoe }}</span>
        <span :class="{ 'red--text font-weight-bold': pool.ipoeShort }">{{ pool.ipoe }}</span>
      </div>

      <div class="mt-2">
        <div class="font-weight-medium">Checklist</div>
        <div v-for="item in checklist" :key="item.key" class="d-flex align-center">
          <v-icon small :color="icon(item).color" class="mr-2">{{ icon(item).name }}</v-icon>
          <span :class="{ 'grey--text text--darken-1': item.state === 'unknown' || item.state === 'manual' }">{{ item.label }}</span>
        </div>
      </div>
    </template>
  </v-card>
</template>

<script>
import { poolSummary, readinessChecklist } from "@/utils/cvcMigrationPage";
import ReadinessText from "./cvc-migration-readiness-text";

const ICONS = {
  ok: { name: "mdi-check-circle", color: "green" },
  fail: { name: "mdi-close-circle", color: "red" },
  warn: { name: "mdi-alert", color: "amber darken-2" },
  unknown: { name: "mdi-help-circle-outline", color: "grey" },
  manual: { name: "mdi-checkbox-blank-outline", color: "grey" },
};

// Why the CVC can or can not move yet: blockers (red), warnings (amber), the
// static IP pool and a checklist.
export default {
  name: "CvcMigrationReadiness",
  components: { ReadinessText },
  props: {
    preflight: { type: Object, default: null },
    lastVerify: { type: Object, default: null },
    // Shown when Preflight failed and there is no earlier answer.
    error: { type: String, default: "" },
    now: { type: Date, required: true },
  },
  computed: {
    warnings () {
      return (this.preflight && this.preflight.warnings) || [];
    },
    pool () {
      return poolSummary(this.preflight);
    },
    checklist () {
      return readinessChecklist(this.preflight, this.lastVerify, this.now);
    },
  },
  methods: {
    icon (item) {
      return ICONS[item.state] || ICONS.unknown;
    },
  },
};
</script>
